module.exports = __webpack_public_path__ + "static/img/gather.cbe539a7.png";